import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { turnOffFullscreen } from '../visual/visual.actions';

@Component({
  selector: 'nns-exit-fullscreen',
  template: `
    <div class="nns-exit-layout" (clickOutside)="onClickOutside()">
      <nns-icon icon="lock"></nns-icon>
      <div class="nns-exit-text">This page is full screen</div>
      <span class="nns-exit-separator"></span>
      <div class="nns-exit-button" (click)="onExitFullScreen()">Exit full screen (ESC)</div>
    </div>
  `,
  host: {
    '[class]': 'classNames'
  },
  styles: [`
    :host{
      position: absolute;
      top: 38px;
      left: 0;
      right: 0;
      margin: 0 auto;
      border: 1px solid #00A1B7;
      border-radius: 4px;
      width: 390px;
      background-color: #fff;
      z-index: 9;
      opacity: 1;
      transition: 0.5s;
    }

    .nns-exit-layout{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 14px 20px;
    }

    .nns-exit-layout nns-icon{
      min-width: 18px;
      min-height: 18px;
    }

    .nns-exit-text{
      margin-left: 5px;
      font-size: 13px;
      font-weight: bold;
      margin-top: 3px;
    }

    .nns-exit-separator{
      height: 19px;
      width: 1px;
      background: #D7D7D7;
      margin-left: 15px;
      margin-right: 15px;
    }

    .nns-exit-button{
      cursor: pointer;
      font-size: 14px;
      color: #00A1B7;
    }

    :host.nns-hide-animation{
      opacity: 0;
    }

    :host.nns-hidden{
      display: none;
    }
    :host-context(.nns-theme-night) {
      background: #20272A;

    }
    :host-context(.nns-theme-night) .nns-exit-button{
      color: #0BB5CC;
    }
    :host-context(.nns-theme-night) .nns-exit-separator{
      background: #fff;
    }
  `]
})

export class ExitFullscreenComponent implements OnInit{
  classNames: string;
  clickNum: number = 0;

  constructor(
    public _store: Store<IAppState>,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.hide();
    }, 2000);
  }

  onExitFullScreen() {
    this._store.dispatch(turnOffFullscreen());
  }

  hide() {
    this.classNames = 'nns-hide-animation';
    setTimeout(() => {
      this.classNames = 'nns-hidden';
    }, 500);
  }

  onClickOutside() {
    if(this.clickNum == 1) {
      this.hide();
    }
    this.clickNum += 1;
  }
}
